module.exports = __webpack_public_path__ + "static/screens-resources-43891ccfbffd38ed4f115f17254b10fb.jpg";